<script lang="ts">

  import { page } from "$app/state"
  import BellIcon from "@lucide/svelte/icons/bell"
  import ClipboardPenLineIcon from "@lucide/svelte/icons/clipboard-pen-line"
  import HomeIcon from "@lucide/svelte/icons/house"
  import LayoutListIcon from "@lucide/svelte/icons/layout-list"
  import Settings2Icon from "@lucide/svelte/icons/settings-2"
  import type { Snippet } from "svelte"

  type NavItemProps = {
    to: string
    icon: Snippet
    label: string
  }

  const prefix = $derived(page.params.prefix ?? "0")

  function isActive(path: string) {
    return page.url.pathname === path
  }

</script>

{#snippet navItem({ to, icon, label }: NavItemProps)}
  <a
    href={to}
    class="flex flex-1 flex-col items-center justify-center py-2"
    class:text-primary={isActive(to)}
    class:text-muted-foreground={!isActive(to)}
    aria-current={isActive(to) ? "page" : undefined}
  >
    {@render icon()}
    <span class="mt-1 text-xs">{label}</span>
  </a>
{/snippet}

<div class="fixed inset-x-0 bottom-0 z-10 mx-auto flex h-14 w-full max-w-3xl justify-center border-t bg-background">
  <nav class="flex w-full max-w-3xl" aria-label="Navigasi utama">
    {@render navItem({ to: `/${prefix}/home`, label: "Beranda", icon: homeIcon })}
    {@render navItem({ to: `/${prefix}/product`, label: "Produk", icon: productIcon })}
    {@render navItem({ to: `/${prefix}/order`, label: "Order", icon: orderIcon })}
    {@render navItem({ to: `/${prefix}/notification`, label: "Notifikasi", icon: notificationIcon })}
    {@render navItem({ to: `/${prefix}/setting`, label: "Pengaturan", icon: settingIcon })}
  </nav>
</div>

{#snippet homeIcon()}
  <HomeIcon class="size-8" aria-hidden="true"/>
{/snippet}

{#snippet productIcon()}
  <LayoutListIcon class="size-8" aria-hidden="true"/>
{/snippet}

{#snippet orderIcon()}
  <ClipboardPenLineIcon class="size-8" aria-hidden="true"/>
{/snippet}

{#snippet notificationIcon()}
  <BellIcon class="size-8" aria-hidden="true"/>
{/snippet}

{#snippet settingIcon()}
  <Settings2Icon class="size-8" aria-hidden="true"/>
{/snippet}
